import { Record } from 'immutable';

import { TTMAudioTypes } from '../constants';

const TimeToMusicEvent = Record(
  {
    ttmAction: null, // The action as defined by ttm work. Not the same as a redux action.
    timeStart: 0, // Time when the measurement started
    audioType: TTMAudioTypes.MUSIC, // The audio type before next track started playing.
  },
  'TimeToMusicEvent',
);

export default TimeToMusicEvent;
